import styled from 'styled-components';

import { PlanOption } from 'src/components/Prompts/PlanOption';

const baseFontSize = 16;

export const StyledVerticalPrompt = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: .5rem;
  font-family: var(--font-family);
  font-size: ${baseFontSize}px;
  line-height: 1.1;

  .header {
    display: flex;
    justify-content: space-between;
    margin: 0 0 1em 0;

    .group {
      display: flex;
      align-items: center;

      .line {
        height: 1.25rem;
        width: 0;
        border: 0.0625rem solid #d1d1d1;
        margin: 0 0.5rem;
      }

      .prompt-text {
        font-style: normal;
        font-weight: 600;
        font-size: 1em;
      }

      .learn-more-btn {
        font-style: normal;
        font-weight: 400;
        font-size: 0.9375em;
        text-align: right;
        text-decoration-line: underline;
      }
    }
  }

  @media (max-width: 373px) { .header { font-size: 14px; } }
  @media (max-width: 345px) { .header { font-size: 13px; } }
  @media (max-width: 329px) { .header { font-size: 12px; } }
  @media (max-width: 316px) { .header { font-size: 11px; } }

  .contracts {
    line-height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const StyledVerticalOption = styled(PlanOption)`
  box-sizing: border-box;
  font-size: inherit;
  font-weight: 500;
  border-radius: 0.5rem;
  cursor: pointer;

  label {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: .5rem;
    line-height: 1.5;
    padding: 0.5em;
    cursor: pointer;
  }

  label.hidden-label {
    padding: 0.5em 1em;
  }

  .info {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // .text {
    //   font-weight: 500;
    // }
  }

  .price {
    display: flex;
    align-items: flex-start;
    font-weight: 600;
  }
`;
